import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Form, Input, Row } from "reactstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { get, post, put } from "helpers/api_helper";
import { PageSubHeader } from "components/CommonLayouts/PageSubHeader";
import Footer from "components/VerticalLayout/Footer";
import * as api from "../../constants/api_constants";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { charactersWithSpaces } from "helpers/validations/regex";
import { zipcode } from "helpers/validations/regex";
import { identificationNumber } from "helpers/validations/regex";
import { showErrorToast, showSuccessToast } from "helpers/toastMessages";
import {
  getAllCountries,
  getCitiesForState,
  getCountryByCode,
  getStatesForCountry,
} from "helpers/utils/locationUtil";
import secureLocalStorage from "react-secure-storage";

function AddCustomer() {
  const [isData, setIsData] = useState({ saved: false, custID: null });
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [fetchedCustomer, setFetchedCustomer] = useState({
    company: "",
    vatNumber: "",
    website: "",
    phone: "",
    primaryContactName: "",
    primaryContactEmail: "",
    primaryContactPhone: "",
    primaryContactDesignation: "",
    currency: "",
    country: "",
    province: "",
    zipcode: "",
    city: "",
    address: "",
    isNavigate: false,
  });
  const navigate = useNavigate();
  const { customerId } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (customerId) {
      fetchCustomerData();
    }
  }, [customerId]);

  useEffect(() => {
    const fetchData = async () => {
      const fetchedCountries = getAllCountries();
      setCountries(fetchedCountries);

      if (fetchedCustomer.country) {
        const fetchedStates = getStatesForCountry(fetchedCustomer.country);
        setStates(fetchedStates);

        if (fetchedCustomer.province) {
          const fetchedCities = getCitiesForState(
            fetchedCustomer.country,
            fetchedCustomer.province
          );
          setCities(fetchedCities);
        }
      }
    };

    fetchData();
  }, [fetchedCustomer]);

  const handleCountryChange = (e) => {
    const selectedCountry = e.target.value;
    validation.setFieldValue("country", selectedCountry);
    const countryDetails = getCountryByCode(selectedCountry);
    if (countryDetails) {
      validation.setFieldValue("currency", countryDetails.currency || "");
    } else {
      validation.setFieldValue("currency", "");
    }

    const fetchedStates = getStatesForCountry(selectedCountry);
    setStates(fetchedStates);
    setCities([]); // Reset cities when country changes
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    validation.setFieldValue("province", selectedState);

    const fetchedCities = getCitiesForState(
      validation.values.country,
      selectedState
    );
    setCities(fetchedCities);
  };

  const fetchCustomerData = async () => {
    try {
      const response = await get(api.GET_CUSTOMER_BY_ID(customerId));
      // console.log("response", response);

      const custData = response?.customerPageResponse?.data[0];
      // console.log("custData",custData);

      // debugger;
      if (custData) {
        setFetchedCustomer({
          company: custData.companyName || "",
          vatNumber: custData.vat || "",
          website: custData.website || "",
          phone: custData.phone || "",
          primaryContactName: custData.primaryContactName || "",
          primaryContactEmail: custData.email || "", // Assuming primary contact email is in the email field
          primaryContactPhone: custData.primaryPhone || "",
          primaryContactDesignation: custData.designation || "",
          currency: custData.currency || "",
          country: custData.country || "",
          province: custData.province || "",
          zipcode: custData.zipCode || "",
          city: custData.city || "",
          address: custData.address || "",
          isNavigate: false, // Keeping this as false unless there's a condition to update it
          paymentTerms: custData.paymentTerms || "",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const storedUser = secureLocalStorage.getItem("authUser");
  const user = JSON.parse(storedUser);
  const updatedDate = new Date().toISOString();

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: fetchedCustomer || {
      company: "",
      vatNumber: "",
      website: "",
      phone: "",
      primaryContactName: "",
      primaryContactEmail: "",
      primaryContactPhone: "",
      primaryContactDesignation: "",
      currency: "",
      paymentTerms: "",
      country: "",
      province: "",
      zipcode: "",
      city: "",
      address: "",
      isNavigate: false,
    },

    validationSchema: Yup.object({
      company: Yup.string()
        .required("Company name is required"),
        // .matches(
        //   charactersWithSpaces,
        //   "First Name should only contain characters"
        // ),
      vatNumber: Yup.string()
        .required("VAT number is required")
        .matches(
          identificationNumber,
          "VAT Number should only contain alphanumeric characters"
        ),
      primaryContactName: Yup.string()
        .required("Contact name is required")
        .matches(
          charactersWithSpaces,
          "First Name should only contain characters"
        ),
      primaryContactPhone: Yup.string()
        .required("Primary Contact Phone is required")
        .test(
          "isValidPhone",
          "Invalid phone number format",
          (value) => !value || isValidPhoneNumber(value)
        ),
      website: Yup.string(),
      primaryContactEmail: Yup.string()
        .email("Invalid email Address")
        .required("Email is required"),
      // phone: Yup.string().test(
      //   "isValidPhone",
      //   "Invalid phone number format",
      //   (value) => !value || isValidPhoneNumber(value)
      // ),
      primaryContactDesignation: Yup.string().matches(
        charactersWithSpaces,
        "Designation should only contain characters"
      ),
      country: Yup.string().required("Country is required"),
      currency: Yup.string().required("Currency is required"),
      paymentTerms: Yup.number("Payment Terms must be an integer"),
      province: Yup.string().required("Province is required"),
      zipcode: Yup.string()
        .required("Zipcode is required")
        .matches(zipcode, "Zip code must be 4-8 characters long"),
      city: Yup.string().required("City is required"),
      address: Yup.string(),
    }),

    onSubmit: async (values) => {
      // debugger;
      const payload = {
        customerTO: {
          customerId: values.customerId, // required for updates
          customerCode: values.customerCode,
          subscriptionId: 100,
          companyName: values.company,
          vat: values.vatNumber,
          currency: values.currency,
          website: values.website,
          designation: values.primaryContactDesignation,
          status: 1,
          primaryPhone: values.primaryContactPhone,
          primaryContactName: values.primaryContactName,
          province: values.province,
          zipCode: values.zipcode,
          city: values.city,
          address: values.address,
          country: values.country,

          email: values.primaryContactEmail,
          phone: values.phone,
          paymentTerms: values.paymentTerms,
          searchKeyword: values.searchKeyword,
          createdBy: user.email,
          // createdDate: updatedDate,
          updatedBy: user.email,
          // updatedDate: updatedDate,
        },
      };

      try {
        if (customerId) {
          const updatedData = await put(
            api.UPDATE_CUSTOMER_DATA_BY_ID(customerId),
            payload
          );
          showSuccessToast("Customer updated successfully");
          if (!updatedData) {
            console.error("Failed to update customer");
            showErrorToast("Failed to update customer");
          }
        } else {
          const responseData = await post(api.CREATE_CUSTOMER, payload);
          const cId = responseData.customerPageResponse.data[0].customerId;
          setIsData((prev) => ({ ...prev, saved: true, custID: customerId }));

          if (values.isNavigate) {
            navigate(`/addShippingBilling/${cId}`);
          } else {
            showSuccessToast("Customer created successfully");
            navigate("/customers");
          }
        }

        if (location.pathname === `/add-customer/${customerId}`) {
          if (values.isNavigate) {
            navigate(`/addShippingBilling/${customerId}`);
          } else {
            navigate("/customers");
          }
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },
  });

  const handleInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");
  };

  const handleAddress = async () => {
    validation.setFieldValue("isNavigate", true);
    validation.handleSubmit();
  };

  return (
    <>
      <div className="page-content">
        <Container fluid={true} style={{ padding: "0px", gap: "10px" }}>
          {customerId ? (
            <PageSubHeader
              heading={"Edit Customer"}
              routePath={"Home"}
              pageName={"Edit Customer"}
            />
          ) : (
            <PageSubHeader
              heading={"Add Customer"}
              routePath={"Home"}
              pageName={"Add Customer"}
            />
          )}
          <Row className="p-4">
            <Col>
              <Card>
                <CardBody>
                  <Form
                    className="row g-3 needs-validation py-2"
                    onSubmit={validation.handleSubmit}
                  >
                    <Row className="card-group">
                      <Col xs={12} className="card-header">
                        <p className="form-header">Customer Information</p>
                      </Col>

                      <Col md={4} className="mb-3">
                        <label htmlFor="company" className="col-form-label">
                          Company Name <span className="text-danger">*</span>
                        </label>
                        <Input
                          id="company"
                          name="company"
                          type="text"
                          className="form-control"
                          placeholder="Company name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.company}
                          invalid={
                            validation.touched.company &&
                            validation.errors.company
                              ? true
                              : false
                          }
                        />
                        {validation.touched.company &&
                        validation.errors.company ? (
                          <div className="invalid-feedback">
                            {validation.errors.company}
                          </div>
                        ) : null}
                      </Col>

                      <Col md={4} className="mb-3">
                        <label htmlFor="country" className="col-form-label">
                          Country <span className="text-danger">*</span>
                        </label>
                        <Input
                          id="country"
                          name="country"
                          type="select"
                          className="form-control"
                          onChange={(e) => handleCountryChange(e)}
                          onBlur={validation.handleBlur}
                          value={validation.values.country}
                          invalid={
                            validation.touched.country &&
                            validation.errors.country
                              ? true
                              : false
                          }
                        >
                          <option value="">Select Country</option>
                          {countries.map((country) => (
                            <option key={country.value} value={country.value}>
                              {country.label}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.country &&
                        validation.errors.country ? (
                          <div className="invalid-feedback">
                            {validation.errors.country}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={4} className="mb-3">
                        <label htmlFor="vatNumber" className="col-form-label">
                          {validation.values.country === "IN" ? "GST" : "VAT"}{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Input
                          id="vatNumber"
                          name="vatNumber"
                          type="text"
                          className="form-control"
                          placeholder={
                            validation.values.country === "IN" ? "GST" : "VAT"
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.vatNumber || ""}
                          invalid={
                            validation.touched.vatNumber &&
                            validation.errors.vatNumber
                              ? true
                              : false
                          }
                        />
                        {validation.touched.vatNumber &&
                        validation.errors.vatNumber ? (
                          <div className="invalid-feedback">
                            {validation.errors.vatNumber}
                          </div>
                        ) : null}
                      </Col>

                      {/* 
                      <Col md={4} className="mb-3">

                      <Row className=" justify-content-start">
                        <Col md={4} className="mb-3">
                          <label htmlFor="company" className="col-form-label">
                            Company Name <span className="text-danger">*</span>
                          </label>
                          <Input
                            id="company"
                            name="company"
                            type="text"
                            className="form-control"
                            placeholder="Company name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.company}
                            invalid={
                              validation.touched.company &&
                              validation.errors.company
                                ? true
                                : false
                            }
                          />
                          {validation.touched.company &&
                          validation.errors.company ? (
                            <div className="invalid-feedback">
                              {validation.errors.company}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} className="mb-3">
                          <label htmlFor="vatNumber" className="col-form-label">
                            VAT / GST <span className="text-danger">*</span>
                          </label>
                          <Input
                            id="vatNumber"
                            name="vatNumber"
                            type="text"
                            className="form-control"
                            placeholder="VAT/GST"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.vatNumber}
                            invalid={
                              validation.touched.vatNumber &&
                              validation.errors.vatNumber
                                ? true
                                : false
                            }
                          />
                          {validation.touched.vatNumber &&
                          validation.errors.vatNumber ? (
                            <div className="invalid-feedback">
                              {validation.errors.vatNumber}
                            </div>
                          ) : null}
                        </Col>
                        {/* <Col md={4} className="mb-3">
>>>>>>> b9a93a273c3901aea45b495ed7eac7cdd6269861
                        <label htmlFor="phone" className="col-form-label">
                          Phone 
                        </label>
                        <PhoneInput
                          international
                          defaultCountry="IN"
                          id="phone"
                          name="phone"
                          type="tel"
                          pattern="[0-9]*"
                          className="form-control d-flex"
                          placeholder="Enter your phone number"
                          onChange={(e) => {
                            validation.setFieldValue("phone", e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.phone}
                          onInput={handleInput}
                          invalid={
                            validation.touched.phone && validation.errors.phone
                              ? true
                              : false
                          }
                        />
                        {validation.touched.phone && validation.errors.phone ? (
                          <div className="phonenumber-invalid">
                            {validation.errors.phone}
                          </div>
                        ) : null}
                      </Col> */}

                      <Col md={4} className="mb-3">
                        <label
                          htmlFor="primaryContactName"
                          className="col-form-label"
                        >
                          Primary Contact Name{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Input
                          id="primaryContactName"
                          name="primaryContactName"
                          type="text"
                          className="form-control"
                          placeholder="Enter Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.primaryContactName}
                          invalid={
                            validation.touched.primaryContactName &&
                            validation.errors.primaryContactName
                              ? true
                              : false
                          }
                        />
                        {validation.touched.primaryContactName &&
                        validation.errors.primaryContactName ? (
                          <div className="invalid-feedback">
                            {validation.errors.primaryContactName}
                          </div>
                        ) : null}
                      </Col>

                      <Col md={4} className="mb-3">
                        <label
                          htmlFor="primaryContactEmail"
                          className="col-form-label"
                        >
                          Primary Contact Email{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Input
                          id="primaryContactEmail"
                          name="primaryContactEmail"
                          type="email"
                          className="form-control"
                          placeholder="Enter Email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.primaryContactEmail}
                          invalid={
                            validation.touched.primaryContactEmail &&
                            validation.errors.primaryContactEmail
                              ? true
                              : false
                          }
                        />
                        {validation.touched.primaryContactEmail &&
                        validation.errors.primaryContactEmail ? (
                          <div className="invalid-feedback">
                            {validation.errors.primaryContactEmail}
                          </div>
                        ) : null}
                      </Col>

                      <Col md={4} className="mb-3">
                        <label
                          htmlFor="primaryContactPhone"
                          className="col-form-label"
                        >
                          Primary Contact Phone Number{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <PhoneInput
                          international
                          defaultCountry="IN"
                          id="primaryContactPhone"
                          name="primaryContactPhone"
                          type="tel"
                          className="form-control d-flex"
                          placeholder="Enter Phone Number"
                          onChange={(e) => {
                            validation.setFieldValue("primaryContactPhone", e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.primaryContactPhone}
                          onInput={handleInput}
                          invalid={
                            validation.touched.primaryContactPhone &&
                            validation.errors.primaryContactPhone
                              ? true
                              : false
                          }
                        />
                        {validation.touched.primaryContactPhone &&
                        validation.errors.primaryContactPhone ? (
                          <div className="phonenumber-invalid">
                            {validation.errors.primaryContactPhone}
                          </div>
                        ) : null}
                      </Col>

                      <Col md={4} className="mb-3">
                        <label
                          htmlFor="primaryContactDesignation"
                          className="col-form-label"
                        >
                          Designation{" "}
                        </label>
                        <Input
                          id="primaryContactDesignation"
                          name="primaryContactDesignation"
                          type="text"
                          className="form-control"
                          placeholder="Enter Designation"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.primaryContactDesignation}
                          invalid={
                            validation.touched.primaryContactDesignation &&
                            validation.errors.primaryContactDesignation
                              ? true
                              : false
                          }
                        />
                        {validation.touched.primaryContactDesignation &&
                        validation.errors.primaryContactDesignation ? (
                          <div className="invalid-feedback">
                            {validation.errors.primaryContactDesignation}
                          </div>
                        ) : null}
                      </Col>

                      {/* <Col md={4} className="mb-3">
                        <label htmlFor="currency" className="col-form-label">
                          Currency
                        </label>
                        <Input
                          id="currency"
                          name="currency"
                          type="text"
                          className="form-control"
                          placeholder="Currency..."
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.currency}
                          invalid={
                            validation.touched.currency &&
                            validation.errors.currency
                              ? true
                              : false
                          }
                          disabled
                        ></Input>
                        {validation.touched.currency &&
                        validation.errors.currency ? (
                          <div className="invalid-feedback">
                            {validation.errors.currency}
                          </div>
                        ) : null}
                      </Col> */}

                      <Col md={4} className="mb-3">
                        <label
                          htmlFor="paymentTerms"
                          className="col-form-label"
                        >
                          Payment Terms (Days)
                        </label>
                        <Input
                          id="paymentTerms"
                          name="paymentTerms"
                          type="text"
                          className="form-control"
                          placeholder="Payment Terms"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.paymentTerms}
                          invalid={
                            validation.touched.paymentTerms &&
                            validation.errors.paymentTerms
                              ? true
                              : false
                          }
                        />
                        {validation.touched.paymentTerms &&
                        validation.errors.paymentTerms ? (
                          <div className="invalid-feedback">
                            {validation.errors.paymentTerms}
                          </div>
                        ) : null}
                      </Col>

                      <Col md={4} className="mb-3">
                        <label htmlFor="website" className="col-form-label">
                          Website
                        </label>
                        <Input
                          id="website"
                          name="website"
                          type="text"
                          className="form-control"
                          placeholder="URL"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.website}
                          invalid={
                            validation.touched.website &&
                            validation.errors.website
                              ? true
                              : false
                          }
                        />
                        {validation.touched.website &&
                        validation.errors.website ? (
                          <div className="invalid-feedback">
                            {validation.errors.website}
                          </div>
                        ) : null}
                      </Col>

                      <Col md={4} className="mb-3">
                        <label htmlFor="province" className="col-form-label">
                          Province <span className="text-danger">*</span>
                        </label>
                        <Input
                          id="province"
                          name="province"
                          type="select"
                          className="form-control"
                          onChange={(e) => handleStateChange(e)}
                          onBlur={validation.handleBlur}
                          value={validation.values.province}
                          invalid={
                            validation.touched.province &&
                            validation.errors.province
                              ? true
                              : false
                          }
                        >
                          <option value="">Select Province</option>
                          {states.map((state) => (
                            <option key={state.value} value={state.value}>
                              {state.label}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.province &&
                        validation.errors.province ? (
                          <div className="invalid-feedback">
                            {validation.errors.province}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={4} className="mb-3">
                        <label htmlFor="city" className="col-form-label">
                          City <span className="text-danger">*</span>
                        </label>
                        <Input
                          id="city"
                          name="city"
                          type="select"
                          className="form-control"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.city}
                          invalid={
                            validation.touched.city && validation.errors.city
                              ? true
                              : false
                          }
                        >
                          <option value="">Select City</option>
                          {cities.map((city) => (
                            <option key={city.value} value={city.value}>
                              {city.label}
                            </option>
                          ))}
                        </Input>
                        {validation.touched.city && validation.errors.city ? (
                          <div className="invalid-feedback">
                            {validation.errors.city}
                          </div>
                        ) : null}
                      </Col>
                      <Col md={4} className="mb-3">
                        <label htmlFor="zipcode" className="col-form-label">
                          Zip Code <span className="text-danger">*</span>
                        </label>
                        <Input
                          id="zipcode"
                          name="zipcode"
                          type="string"
                          className="form-control"
                          placeholder="Enter zip code"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.zipcode}
                          invalid={
                            validation.touched.zipcode &&
                            validation.errors.zipcode
                              ? true
                              : false
                          }
                        ></Input>
                        {validation.touched.zipcode &&
                        validation.errors.zipcode ? (
                          <div className="invalid-feedback">
                            {validation.errors.zipcode}
                          </div>
                        ) : null}
                      </Col>

                      <Col md={4} className="mb-2">
                        <label htmlFor="address" className="col-form-label">
                          Address
                        </label>
                        <Input
                          type="textarea"
                          id="address"
                          name="address"
                          maxLength="225"
                          rows="1"
                          className="form-control"
                          placeholder="Enter your address"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.address}
                          invalid={
                            validation.touched.address &&
                            validation.errors.address
                              ? true
                              : false
                          }
                        />
                        {validation.touched.address &&
                        validation.errors.address ? (
                          <div className="invalid-feedback">
                            {validation.errors.address}
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                    {/* </Row> */}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Footer
          save={validation.handleSubmit}
          buttons={[
            {
              text: customerId
                ? "Edit Billing/Shipping"
                : "Save and Add Billing/Shipping",
              color: "primary",
              onClick: customerId
                ? () => navigate(`/addShippingBilling/${customerId}`)
                : () => handleAddress(),
            },
          ]}
        />
      </div>
    </>
  );
}

export default AddCustomer;
